export default __webpack_public_path__ + "static/media/OB-Lulu-Briggs-Logo.a2d4d3c4.png";